import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectionStrategy, Component, OnInit, Inject, ViewChild, ViewEncapsulation, ElementRef} from '@angular/core';
import { MatSort, MatSortable } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { AppUtils } from 'projects/dialog/src/app/shared/utilities/app-utils';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'dl-view-reminder-details',
  templateUrl: './view-reminder-details.component.html',
  styleUrls: ['./view-reminder-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ]),
  ],
})
export class ViewReminderDetailsComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) public sort: MatSort;
  public displayedColumns = ['ReminderSubject', 'ReminderSendDate', 'ReminderDueDate', 'ReminderSendStatus', 'expandTrigger'];
  public dataSource = new MatTableDataSource<any>();
  public selection = new SelectionModel(true, []);
  public selectedRow: any;
  public notificationData = this.data.notificationData;
  public customerData = this.data.customerData;
  public notificationReminderData = this.notificationData.NotificationReminders;
  public customerReminderData = this.customerData.CustomerReminderDetails;
  public tableData: any[] = this.notificationReminderData;
  public expandedElement: any;
  constructor(public appUtils: AppUtils, private router: Router, private readonly dialog: MatDialog, public dialogRef: MatDialogRef<ViewReminderDetailsComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  ngOnInit(): void {
    // console.log(this.notificationData);
    // this.tableData = this.notificationReminderData.map((item, i) => Object.assign({}, item, this.customerReminderData[i]));
    this.tableData = this.customerReminderData.map((item, i) => {
      const reminderItem = this.notificationReminderData.filter(reItem => reItem.ReminderId === item.ReminderId);
      return Object.assign({}, reminderItem[0], item);
    });
    this.sort.sort(({ id: 'ReminderDueDate', start: 'asc'}) as MatSortable);
    this.dataSource.sort = this.sort;
    this.dataSource.data = this.tableData;
  }

  public displayStatus(status: string): string {
    const statusText = status === 'Not Sent' ? 'Scheduled' : status === 'Delivered' ? 'Sent' : status;
    return statusText;
  }

  public getLastReminderSent(): string {
    const allSentData = this.tableData.filter(item => item.ReminderSendStatus === 'Delivered');
    const allFailedData = this.tableData.filter(item => item.ReminderSendStatus === 'Delivery Failed');
    let lastReminderSent = '';
    if (allSentData.length > 0) {
      lastReminderSent = this.appUtils.formatDateWithTime(allSentData[allSentData.length - 1].ReminderSendDate);
      // lastReminderSent = Math.max.apply(Math, allSentData.map(function(reminder){return reminder.ReminderSendDate}));      
    } else if (allFailedData.length > 0) {
      lastReminderSent = this.appUtils.formatDateWithTime(allFailedData[allFailedData.length - 1].ReminderDeliveryFailedDate);
    }
    
    return lastReminderSent;
  }

  public expandDetails(element) {
    this.expandedElement = this.expandedElement === element ? null : element;
  }

  public expandToggle(element: any) {
    this.expandedElement = this.expandedElement !== element && !element.disabled ? element : null;
  }

  public isExpanded(row: any) {
    return row === this.expandedElement;
  }
}
